var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import inviteService from "../../api/AccountService";
import { copy } from '../../helper/clipboard';
import html2canvas from "html2canvas";
import QRCode from "qrcodejs2";
var inviteCustomer = (function (_super) {
    __extends(inviteCustomer, _super);
    function inviteCustomer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inviteInfo = {};
        _this.clipboardCopy = copy;
        return _this;
    }
    inviteCustomer.prototype.created = function () {
        this.service = inviteService.getInstance();
        this.getinviteInfo();
    };
    inviteCustomer.prototype.mounted = function () {
    };
    inviteCustomer.prototype.createQrcode = function () {
        var qrcodeImgEl_one = document.getElementById('qrcodeImg1');
        var qrcodeImgEl = document.getElementById('qrcodeImg');
        var qrcode1 = new QRCode(qrcodeImgEl_one, {
            width: 285,
            height: 285,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H,
            text: this.inviteInfo.shop_website,
        });
        var qrcode = new QRCode(qrcodeImgEl, {
            width: 285,
            height: 285,
            colorDark: '#000000',
            colorLight: '#ffffff',
            correctLevel: QRCode.CorrectLevel.H,
            text: this.inviteInfo.shop_website,
        });
    };
    inviteCustomer.prototype.getinviteInfo = function () {
        var _this = this;
        var loadingInstance = Loading.service({ fullscreen: true });
        this.service.getinviteInfo().then(function (res) {
            loadingInstance.close();
            _this.inviteInfo = res.data.data ? res.data.data : {};
            _this.createQrcode();
        })
            .catch(function (err) {
            loadingInstance.close();
            _this.$message.error(err.message);
        });
    };
    inviteCustomer.prototype.download = function (val) {
        document.documentElement.scrollTop = 0;
        document.body.scrollTop = 0;
        var node = document.getElementById(val);
        var width = node.offsetWidth;
        var height = node.offsetHeight;
        var scale = 2;
        html2canvas(node, {
            width: width,
            heigth: height,
            backgroundColor: "#ffffff",
            dpi: window.devicePixelRatio * 2,
            scale: scale,
            X: 0,
            Y: 0,
            scrollX: -3,
            scrollY: 0,
            useCORS: true,
            allowTaint: true
        }).then(function (canvas) {
            var url = canvas.toDataURL();
            var a = document.createElement("a");
            a.download = "扫码注册商城";
            var event = new MouseEvent("click");
            a.href = url;
            a.dispatchEvent(event);
        });
    };
    inviteCustomer = __decorate([
        Component({})
    ], inviteCustomer);
    return inviteCustomer;
}(Vue));
export default inviteCustomer;
